<script setup lang="ts"></script>
<template>
  <div
    class="spinner-wrapper position-absolute bottom-0 left-0 right-0 top-0 mx-auto d-flex h-100 w-100 align-center justify-center rounded border border-sm"
  >
    <div class="d-flex align-center">
      <svg
        class="spinner-svg animate-spin"
        fill="none"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          class="spinner-circle"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          stroke-width="4"
        ></circle>
        <path
          class="spinner-path"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          fill="currentColor"
        ></path>
      </svg>
    </div>
  </div>
</template>

<style scoped lang="postcss">
.spinner-wrapper {
  z-index: 10;
  max-width: 488px;
  background-color: rgb(255 255 255 / 0.6);
  border-color: rgb(0 0 0 / 0.1);
  object-fit: contain;
}

.spinner-svg {
  width: 8px;
  height: 8px;
}

.spinner-circle {
  opacity: 0.25;
}

.spinner-path {
  opacity: 0.75;
}
</style>
